// extracted by mini-css-extract-plugin
module.exports = {"radioGroupBaseRoot":"RadioGroupBase_radioGroupBaseRoot__o3wIW","horizontal":"RadioGroupBase_horizontal__w_GXq","vertical":"RadioGroupBase_vertical__P8x3x"};